import classNames from 'classnames';
import { forwardRef } from 'react';
const visuallyHiddenCss = "v1wr8w98";
const VisuallyHidden = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(visuallyHiddenCss, props.className)} />;
});
export const AriaAnnouncement = ({
  announcement = '',
  politeness = 'assertive'
}) => {
  if (announcement) {
    return <VisuallyHidden aria-live={politeness} aria-atomic="true">
        {announcement}
      </VisuallyHidden>;
  }
  return null;
};

require("./aria_announcement.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./aria_announcement.js");